import React, { useState } from "react";
import { useDispatch } from "react-redux";
import DetailsCartRow from "./DetailsCartRow";
import EditCartForm from "./EditCartForm";
import PendingProduct from "../Product/PendingProduct";
import { updateCart } from "../../../../redux/reducer/cartReducer";

const DetailsCartTable = ({
  details,
  onDelete,
  onUpdate,
  isEditing,
  setEditingOrder,
  isProducts,
  setEditingProducts,
  refreshData,
  loading,
}) => {
  const dispatch = useDispatch();
  // State for price form and edit form

  const [show, setShow] = useState(false);

  // console.log(show)

  const [editForm, setEditForm] = useState({
    note: details.note || "",
  });

  const handleDetails = () => {
    setShow(true);
    setEditingProducts(details.id);
  };

  const handleEdit = () => {
    setEditForm({
      note: details.note || "",
    });
    setEditingOrder(details.id);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();
    const updatedData = {
      size: editForm.Size,
      productCount: editForm.Count,
    };
    dispatch(updateCart({ id: details.id, data: updatedData }));
    setEditingOrder(null);
    if (onUpdate) onUpdate(updatedData);
  };

  // console.log(details)
  return (
    <>
      <DetailsCartRow
        details={details}
        onDelete={onDelete}
        onEdit={handleEdit}
        onDetails={handleDetails}
      />
      {(isEditing || isProducts) && (
        <tr>
          <td colSpan="100%">
            {isEditing ? (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
                <EditCartForm
                  editForm={editForm}
                  onChange={handleEditChange}
                  onSubmit={handleEditSubmit}
                  onCancel={() => setEditingOrder(null)}
                />
              </div>
            ) : (
              <div
                className={`fixed inset-0 h-full z-50 overflow-y-auto bg-yellow-50 transform transition-transform duration-700 ease-out ${
                  show
                    ? "translate-x-0 duration-700"
                    : "translate-x-full duration-700"
                }`}
              >
                <div className="mt-5 md:mx-5 md:mt-10 ">
                  <PendingProduct
                    data={details.products}
                    cartID={details.id}
                    setEditingProducts={setEditingProducts}
                    refreshData={refreshData}
                    loading={loading}
                  />
                </div>
              </div>
            )}
          </td>
        </tr>
      )}
    </>
  );
};

export default DetailsCartTable;
